export default __webpack_public_path__ + "static/media/ArrowUp.b8d6214d.svg";